<template>
  <section class="f-39">
    <div class="alive_content">
      <div class="title f-center-title">无界兼容，设计更通用</div>
      <div class="card f-select-center" v-ia>
        <div class="card_title">
          <div>屏幕百态</div>
          <div>适配自如</div>
        </div>
        <m-video
          ref="video1"
          class="video_size"
          disablepictureinpicture
          muted
          playsinline
          webkit-playsinline
          poster="@/v2/auto/assets/video/39/poster/1.jpg"
          src="@/v2/auto/assets/video/39/1.mp4"
        />
        <replay class="replay" @click="replayVideo($refs.video1)" />
      </div>
      <div class="card f-select-center" v-ia>
        <div class="card_title">
          <div>多国语言</div>
          <div>跨国畅用</div>
        </div>
        <m-video
          ref="video2"
          class="video_size"
          disablepictureinpicture
          muted
          playsinline
          webkit-playsinline
          poster="@/v2/auto/assets/video/39/poster/2.jpg"
          src="@/v2/auto/assets/video/39/2.mp4"
        />
        <replay class="replay" @click="replayVideo($refs.video2)" />
      </div>
    </div>
  </section>
</template>
<script>
import { videoPlayByVisibleArea, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    this.videoRunner()
  },
  methods: {
    replayVideo,
    videoRunner() {
      const video1 = this.$refs.video1
      const video2 = this.$refs.video2
      video1 && videoPlayByVisibleArea(video1)
      video2 && videoPlayByVisibleArea(video2)
    },
  },
}
</script>
<style lang="less" scoped>
.f-39 {
  position: relative;
  z-index: 79;
  .alive_content {
    background: #ffffff;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin: 100px 0;
      font-weight: 700;
      display: flex;
      // 设置背景
      background: radial-gradient(
        83.84% 58.59% at 49.68% 19.19%,
        #2e63ca 0%,
        #91a8e4 100%
      );
      // 背景作用于字体上
      background-clip: text;
      // 字体透明
      color: transparent;
      .title_bold {
        font-weight: 700;
      }
    }
    .card {
      height: auto;
      position: relative;
      aspect-ratio: 1200 / 580;
      display: flex;
      overflow: hidden;
      justify-content: space-between;
      align-items: center;
      background-color: #f5f5f5;
      border-radius: 30px;
      margin-bottom: 20px;
      // 避免视频底部出现黑边
      // &::after {
      //   content: '';
      //   position: absolute;
      //   width: 100%;
      //   height: calc(100% - 1px);
      //   z-index: 1;
      //   top: 0;
      //   left: 0;
      //   border-color: #f5f5f5;
      //   border-width: 0 0 5px 0;
      //   border-radius: 30px;
      //   border-style: solid;
      // }
      .card_title {
        position: absolute;
        z-index: 1;
        height: 100%;
        left: 10%;
        color: black;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        font-size: 32px;
        line-height: 1.4;
        font-weight: 700;
      }
      .video_size {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 0;
        object-fit: cover;
        border-radius: 30px;
      }
    }
    .replay {
      position: absolute;
      z-index: 2;
      bottom: 20px;
      right: 20px;
      color: #3b82fc;
    }
  }
}
</style>
